var _g, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 820.25417,
    height: 645.76932,
    viewBox: "0 0 820.25417 645.76932",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215.14368,291.44366c-1.80561,0-3.27392,1.46831-3.27392,3.27392v26.1914c0,1.80561,1.46831,3.27392,3.27392,3.27392s3.27392-1.46831,3.27392-3.27392v-26.1914c0-1.80561-1.46831-3.27392-3.27392-3.27392Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.53737,0H293.03992c-33.39617,0-60.46911,27.07294-60.46911,60.46911V580.86906c0,33.3961,27.07289,60.46899,60.46899,60.46899h294.49758c33.39617,0,60.46911-27.07294,60.46911-60.46911V60.46911c0-33.39617-27.07294-60.46911-60.46911-60.46911Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.53754,645.76932H293.03995c-34.1321,0-61.90106-27.76825-61.90106-61.90036V63.4694c0-34.1321,27.76895-61.90106,61.90106-61.90106h294.49759c34.1321,0,61.90106,27.76895,61.90106,61.90106V583.86896c0,34.1321-27.76895,61.90036-61.90106,61.90036ZM293.03995,4.43215c-32.55338,0-59.03725,26.48388-59.03725,59.03725V583.86896c0,32.55338,26.48388,59.03655,59.03725,59.03655h294.49759c32.55338,0,59.03725-26.48318,59.03725-59.03655V63.4694c0-32.55338-26.48388-59.03725-59.03725-59.03725H293.03995Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.86965,126.80419h-118.3722c-5.02073,0-9.10555-4.08483-9.10555-9.10555s4.08483-9.10555,9.10555-9.10555h118.3722c5.02073,0,9.10555,4.08483,9.10555,9.10555s-4.08483,9.10555-9.10555,9.10555Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.8209,198.4097h-115.06341c-2.90084,0-5.2612-2.36037-5.2612-5.2612,0-2.90084,2.36036-5.2601,5.2612-5.2601h115.06341c2.90084,0,5.2601,2.35927,5.2601,5.26011,0,2.90084-2.35926,5.2612-5.2601,5.2612Z",
    fill: "#49BCD2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.05382,
    y: 22.55692,
    width: 66.58064,
    height: 8.53598,
    rx: 0.31021,
    ry: 0.31021,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556.46311,
    cy: 24.26412,
    r: 6.82878,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.24227,
    cy: 24.26412,
    r: 6.82878,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594.02142,
    cy: 24.26412,
    r: 6.82878,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.32311,226.57123c0,.9451,.75895,1.70397,1.70405,1.70397h292.52305c.94502,0,1.70397-.75886,1.70397-1.70397,0-.94502-.75895-1.70397-1.70397-1.70397H294.02716c-.9451,0-1.70405,.75895-1.70405,1.70397Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.32311,467.57123c0,.9451,.75895,1.70397,1.70405,1.70397h292.52305c.94502,0,1.70397-.75886,1.70397-1.70397,0-.94502-.75895-1.70397-1.70397-1.70397h-292.52305c-.9451,0-1.70405,.75895-1.70405,1.70397Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.49856,360.4981h-175.54826c-2.90084-.00001-5.2612-2.36037-5.2612-5.26121,0-2.90084,2.36036-5.2601,5.2612-5.2601h175.54826c2.90084,.00001,5.2601,2.35928,5.2601,5.26012,0,2.90084-2.35926,5.2612-5.2601,5.2612Z",
    fill: "#49BCD2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.70574,
    cy: 354.58702,
    r: 12.88711,
    fill: "#49BCD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.27371,376.06554v-2.8638c10.65885,0,19.33066-8.67181,19.33066-19.33066s-8.67181-19.33066-19.33066-19.33066v-2.8638c12.23828,0,22.19447,9.95619,22.19447,22.19447s-9.95619,22.19447-22.19447,22.19447Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-9e40be56-d004-4de8-84cd-e8041855938b-52",
    d: "M174.78102,302.61468c5.25679-5.34964,12.27813-6.97361,15.68213-3.62759,3.404,3.34602,1.90142,10.39391-3.35796,15.74475-2.07159,2.16626-4.63183,3.80492-7.46654,4.77886l-22.55949,22.38538-10.27915-10.81042,23.33099-20.92029c.92475-2.85215,2.51925-5.4413,4.65003-7.55069Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.63289,284.13678l23.65312,52.47301,37.77041-20.44495,13.51734,7.17415s-30.87649,51.61987-52.01762,45.74362c-21.14112-5.87625-58.68228-59.15807-51.9183-75.60245,6.76399-16.44438,28.99505-9.34339,28.99505-9.34339Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,644.013c0,.66003,.53003,1.19,1.19006,1.19H730.48004c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.32235,
    cy: 323.94725,
    rx: 64.899,
    ry: 63.53157,
    fill: "#49BCD2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "92.26132 633.8482 109.50824 633.84652 117.7127 567.32191 92.25785 567.32369 92.26132 633.8482",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.35145,633.45696h0c.53701,.90442,.82036,3.8235,.82036,4.87526h0c0,3.23286-2.62071,5.85368-5.85368,5.85368h-53.41172c-2.20544,0-3.9934-1.78786-3.9934-3.9934v-2.2237s-2.64222-6.68338,2.79765-14.92101c0,0,6.76104,6.45019,16.86377-3.65254l2.97921-5.39706,21.56534,15.7718,11.95334,1.47134c2.61515,.32187,4.93372-.04995,6.27892,2.21562h.00021Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "105.31209 287.50403 105.66093 264.24193 91.31588 255.29975 75.71734 274.38013 105.31209 287.50403",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.31209 287.50403 106.24058 264.82158 91.31588 255.29975 96.38655 283.37034 105.31209 287.50403",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.15003,441.32461l-23.7656,161.72199h-29.81713l3.96481-92.31486,2.08672-48.53978-6.05153-23.10479s-2.75913-5.13571-5.08353-11.36114c-2.61999-7.02534-4.68934-15.44762-1.61721-19.44141,1.13032-1.47233,4.06915-2.56207,8.0629-3.37356,2.44033-.49849,5.28063-.88688,8.34696-1.18827,17.6329-1.74475,42.71432-.65501,42.71432-.65501l.6376,21.04124,.35361,11.74949,.16809,5.46608Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "61.88026 625.93901 78.944 628.44604 96.73768 563.82234 71.55329 560.12152 61.88026 625.93901",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39886,634.14701h0c.39974,.97292,.25548,3.90216,.1025,4.94274h0c-.47024,3.19848-3.4443,5.41022-6.64288,4.93996l-52.84366-7.76911c-2.18198-.3208-3.69088-2.34971-3.37006-4.5318l.32345-2.20005s-1.64198-6.99663,4.93826-14.35538c0,0,5.75091,7.36503,17.2157-1.16074l3.73256-4.90631,19.04187,18.74089,11.6122,3.19439c2.54052,.69884,4.88851,.66822,5.88986,3.10537l.00021,.00003Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.52406,414.3539l-3.25967,28.07231-17.77661,59.15589-29.26327,97.39091-29.49673-4.3348,26.47299-138.4754-2.62124-23.74478s-.85365-2.36026-1.83218-5.81567c-1.9423-6.83602-4.37839-17.9685-1.6983-23.6471,.36189-.77192,.81618-1.44168,1.37819-1.984,1.05413-1.02229,3.19659-1.64307,6.067-1.97236,11.99776-1.35598,36.7064,2.52236,47.70111,4.42623l4.32871,10.92876Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.99709,269.45877l28.98244,13.91157s30.72138,91.00485,30.72138,95.64204c0,4.63719,8.69473,7.53543,3.47789,12.75227s9.70997,9.63495,1.66692,13.80203c-8.04305,4.16708-58.21688,26.96048-63.79598,24.90502-15.38743-5.66905,.65206-26.50019,.65206-26.50019,0,0-11.55874-9.30861-9.8198-13.9458,1.73895-4.63719-10.43368-93.32344-10.43368-93.32344l18.54876-27.24349Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "uuid-73aedec7-8a7b-498d-9bbc-62d5085a8040-53",
    d: "M167.30945,349.6482c7.19283-2.12502,14.11967-.13622,15.4713,4.44157,1.35163,4.57779-3.38348,10.01003-10.57916,12.13485-2.86274,.8882-5.89656,1.07793-8.84763,.55327l-30.59003,8.61893-3.73863-14.44122,30.55328-6.96353c2.19307-2.0446,4.844-3.53412,7.73088-4.34387Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.20352,298.46878l-4.79452,57.35765,42.94632,.46178,8.3349,12.83418s-52.05339,30.1399-67.68354,14.73938c-15.63015-15.40051-22.58474-80.20734-8.68819-91.30036,13.89655-11.09302,29.88503,5.90736,29.88503,5.90736Z",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 104.70794,
    cy: 246.16303,
    r: 24.8276,
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.31667,246.26078s3.90986-6.45127,6.06028-9.77465c2.15042-3.32338,2.15042-8.19223,2.15042-8.19223,0,0,19.94028-.40946,26.58704,5.25984s11.33859-15.24845,4.88732-22.48169c0,0-2.7369,3.12789-2.15042,4.30084l.58648,1.17296s-3.32338-13.29352-12.90253-15.83493c0,0-5.32882,2.75229-3.83737,4.30854,1.49145,1.55625-11.41108-9.39136-15.32094-2.94009,0,0-9.57915-.19549-8.4062,3.32338l-.58648,2.15042s-8.2107-2.54141-8.79718,3.51887c0,0,2.93239,0,4.49634,1.56394,1.56394,1.56394-5.66929,6.06028-5.66929,6.06028,0,0-8.4062,23.06817,2.93239,32.45183,0,0,.09775-11.24084,4.59408-8.50394s5.37606,3.61662,5.37606,3.61662Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "114.94395 260.92275 114.0525 263.26866 120.73836 263.46416 121.18408 261.31373 114.94395 260.92275",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.62981,252.51655s-10.02879-2.7369-16.04606,5.4738l-1.33717,1.56394s-12.70313-14.27098-11.58882-19.54929l-2.67434,.19549-2.67434,13.68451s8.46875,14.66197,20.28044,15.24845c0,0,11.36596,2.7369,13.81744-1.95493,2.45148-4.69183,6.67217-11.61018,6.67217-11.61018l-6.44931-3.05179Zm-1.82414,13.09803h-6.64462c-1.56003,0-5.57155-5.66929-5.57155-5.66929,2.22862-3.51887,8.91448-3.71437,8.91448-3.71437h7.26053l.53963,2.15042-4.49848,7.23324Z",
    fill: "#2f2e41"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "605.59886 635.7374 594.69788 633.38103 598.59696 590.2126 614.68589 593.68994 605.59886 635.7374",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.30337,627.42054h0c-.46294,.49832-1.04067,2.30467-1.18431,2.96946h0c-.44149,2.04338,.85706,4.05781,2.90051,4.49931l33.75978,7.29411c1.39399,.30118,2.76825-.58469,3.06945-1.97874l.30368-1.40553s2.58277-3.86351,.26937-9.81313c0,0-5.15429,3.15364-10.16022-4.61163l-1.14602-3.81815-15.7846,7.02379-7.75625-.70241c-1.6969-.15369-3.11162-.70534-4.27127,.54295l-.00013-.00003Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "586.1002 632.43486 577.00573 625.97928 597.57611 587.82727 610.99896 597.35474 586.1002 632.43486",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.08568,610.11394h0c-.62167,.27597-1.86357,1.70928-2.25719,2.26393h0c-1.2099,1.70484-.80873,4.06772,.89616,5.27766l28.16645,19.98944c1.16303,.82539,2.77501,.55172,3.60044-.61137l.83222-1.17266s3.89463-2.53559,4.10889-8.91556c0,0-5.9794,.87115-7.52607-8.23745l.44879-3.96109-17.27502,.24632-6.8542-3.69766c-1.49955-.80899-2.58308-1.8728-4.14036-1.1815l-.00011-.00008Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M717.11687,419.00777s16.95934,23.05759-16.95934,48.98068l-69.25065-22.12838,24.73238-51.58467,21.90582-12.01287,39.5718,36.74524Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "630.90688 445.86006 604.05458 498.15137 587.09524 606.97383 608.29442 608.3871 629.4936 505.21776 666.94548 449.39326 640.79983 437.38039",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.15753,451.56325v16.42519l-48.05147,52.77539s0,39.5718-18.37262,57.94442l-21.19918,32.50541-18.37262-9.89295,26.85229-94.68967,48.05147-62.18426,31.09213,7.11647Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.01149,288.72346l7.28678,34.51082,27.78085-6.78901s-13.73254-28.5619-11-39.87692l-24.06763,12.15511Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.01149,288.72346l7.28678,34.51082,27.78085-6.78901s-13.73254-28.5619-11-39.87692l-24.06763,12.15511Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.3845,293.9326l-21.19918,9.89295s-10.90561,6.66578-11.10592,11.10592c-.20031,4.44014,1.21297,25.63932,1.21297,25.63932,0,0-8.47967,8.47967-2.82656,25.43902l-2.82656,28.26557,63.59754,33.91869-5.65311-59.3577,2.82656-55.11787-24.02574-19.7859Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "uuid-8e851e4b-a66f-4616-8a31-24a5e3f3093d-54",
    d: "M711.41349,454.76606c-2.48209,5.69491-7.43245,9.03041-11.05647,7.45019-3.62402-1.58022-4.54888-7.47701-2.06514-13.17361,.96094-2.28917,2.45612-4.31493,4.36045-5.90778l10.82145-23.99674,11.15273,5.31822-11.8521,23.09191c.12931,2.48011-.33735,4.95511-1.36092,7.21782Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.15753,317.2517s15.54607-9.89295,21.19918,1.41328c5.65311,11.30623,18.37262,69.25065,18.37262,69.25065l-18.37262,55.11787-16.95934-7.06639,14.83943-59.31875-19.07926-59.39665Z",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "uuid-35301953-803a-439b-9845-5bf97a98fdf5-55",
    d: "M620.48064,445.8694c-4.40555,4.37995-10.23654,5.65711-13.0235,2.85293-2.78697-2.80418-1.47437-8.62694,2.93333-13.00786,1.73669-1.77415,3.873-3.1066,6.23021-3.88585l18.90084-18.32228,8.40905,9.05288-19.52566,17.10139c-.79347,2.35331-2.13911,4.48232-3.92428,6.20879Z",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.67726,313.88028s27.10332-1.10843,28.19356,11.48521c1.09024,12.59365-17.43792,68.78704-17.43792,68.78704l-37.38606,44.47263-13.16323-12.81728,35.649-49.6797,4.14466-62.24791Z",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M738.93506,463.12731l-173.30842-27.95322c-2.86383-.46191-4.81822-3.168-4.35631-6.03183,.46191-2.86383,3.16783-4.81714,6.03166-4.35523l173.30842,27.95322c2.86383,.46191,4.81731,3.16675,4.3554,6.03057-.46191,2.86383-3.16692,4.81839-6.03075,4.35648Z",
    fill: "#49BCD2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514.00268,
    cy: 420.86012,
    r: 12.88711,
    fill: "#49BCD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.16881,441.83656l.45601-2.82726c10.52286,1.69725,20.46476-5.48238,22.16212-16.00593,1.69725-10.52286-5.48307-20.46487-16.00593-22.16212l.45601-2.82726c12.08213,1.94875,20.32592,13.36326,18.37718,25.44539-1.94875,12.08213-13.36326,20.32592-25.44539,18.37718Z",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 668.79044,
    cy: 274.71441,
    r: 21.34417,
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.40367,274.71441s-13.3247-12.09503-21.86237-7.8262c-8.53767,4.26883-12.8065,7.11472-12.8065,7.11472,0,0-7.11472-10.67209,3.55736-19.92123,0,0-21.72169-9.49003-5.88054-24.31051,15.84115-14.82047,30.0706-9.1287,30.0706-9.1287,0,0,19.20976,8.53767,5.69178,25.61301,0,0,19.69339,12.48951,9.49096,32.92497,0,0-.95329-13.00374-3.79918-9.44638s-4.46211,4.98031-4.46211,4.98031Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.62026,347.86716c-8.1595-20.06132-16.31912-40.12252-24.47862-60.18372-1.12695-2.77073-4.65719-2.86911-5.75705,0-8.06208,21.03255-13.33049,42.97924-15.86326,65.35604-.43132,3.81143,5.5423,3.7807,5.97022,0,.99115-8.7565,2.46257-17.44753,4.35159-26.04588,6.72355,.35273,13.50236-.40156,19.99075-2.19778,3.34319,8.2195,6.68638,16.43888,10.02945,24.65839,1.42854,3.51227,7.20625,1.97623,5.75693-1.58706Zm-34.4234-26.77576c2.01097-8.23128,4.42179-16.36479,7.21912-24.36772l9.15029,22.49693c-5.3595,1.40668-10.84059,2.03247-16.36941,1.8708Z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 252.12709,
    cy: 346.88466,
    r: 6,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.12709,
    cy: 293.88466,
    r: 6,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWork);
export default __webpack_public_path__ + "static/media/ChatWork.286b8cac55461cd77bc5c9993732d027.svg";
export { ForwardRef as ReactComponent };